import React from 'react';
import { Button, Dropdown } from 'tdesign-react';

const { DropdownMenu, DropdownItem } = Dropdown;

/**
 * 教育 Agent 参数渲染器
 */
function EduAgentRenderer({ rectOptions, eduValue, setEduValue, onSelect }) {
  return (
    <div className="eduAgent-params-container">
      <span className="eduAgent-params-container__tips">请帮我批改</span>
      <Dropdown
        hideAfterItemClick
        placement="bottom-left"
        trigger="hover"
      >
        <Button variant="text">
          <div className="eduAgent-params__select">
            <span
              style={{
                color: eduValue?.titleStyle?.activeColor || '#4A70FF',
                background: eduValue?.titleStyle?.bgColor || '#F1F6FF'
              }}
              className="eduAgent-params__optionitem placeholder"
            >
              {eduValue?.label || '请选择题目'}
              <div className="eduAgent-params__collops"></div>
            </span>
          </div>
        </Button>
        <DropdownMenu>
          {rectOptions.map((option, idx) => (
            <DropdownItem
              key={idx}
              onClick={() => {
                setEduValue(option);
                onSelect && onSelect(option.value, option.value, option);
              }}
            >
              <div style={{ margin: '4px 0' }}>
                <span
                  style={{
                    color: option.titleStyle.activeColor,
                    background: option.titleStyle.color
                  }}
                  className="eduAgent-params__optionitem"
                >
                  {option.label}
                </span>
              </div>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
      <span className="eduAgent-params-container__tips">，输出答案与计算步骤，以json格式输出。</span>
    </div>
  );
}

export default EduAgentRenderer;
